import { CircularProgress } from '@mui/material';

const Spinner = () => {
    return (
        <div className="loader-wrapper">
            <CircularProgress color='primary' thickness={3} size={44} />
        </div>
    );
};

export default Spinner;
